module.exports = __webpack_public_path__ + "abb9410d186921efe33ba7ac080bb01b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/chef-jacket.png
// module id = 1256
// module chunks = 0